// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1KM95","active":"downloadDropdown_active__26hue"};